function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { PureComponent } from 'react';
import { Icon } from '@els/els-react--icon';
import { makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var bool$1 = PT.bool,
  func$1 = PT.func,
  node$1 = PT.node,
  string$1 = PT.string;
var Pill = /*#__PURE__*/function (_PureComponent) {
  function Pill() {
    _classCallCheck(this, Pill);
    return _callSuper(this, Pill, arguments);
  }
  _inherits(Pill, _PureComponent);
  return _createClass(Pill, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        condensed = _this$props.condensed,
        id = _this$props.id,
        label = _this$props.label,
        onClick = _this$props.onClick,
        onClose = _this$props.onClose,
        pillColor = _this$props.pillColor,
        textColor = _this$props.textColor;
      if (!children && !label) {
        throw new TypeError("Must supply children or label (deprecated).");
      }
      if (label) {
        console.warn("Label is deprecated, use children instead");
      }
      var classes = classnames("c-els-pill", className, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "u-els-background-color-".concat(pillColor), pillColor), "u-els-color-".concat(textColor), textColor), "c-els-pill--condensed", condensed), "c-els-pill--clickable", onClick || onClose));
      var closeIcon = /* @__PURE__ */React.createElement(Icon, {
        className: "c-els-pill__close-icon",
        size: "xxs",
        sprite: Icon.Sprites.CLOSE
      }, "Close");
      var renderChildren = function renderChildren() {
        if (onClick && onClose) {
          return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("button", {
            className: "c-els-pill__button",
            onClick: onClick,
            type: "button"
          }, children || label), /* @__PURE__ */React.createElement("button", {
            className: "c-els-pill__close-button",
            onClick: onClose,
            type: "button"
          }, closeIcon));
        }
        if (onClick) {
          return /* @__PURE__ */React.createElement("button", {
            className: "c-els-pill__button",
            onClick: onClick,
            type: "button"
          }, children || label);
        }
        if (onClose) {
          return /* @__PURE__ */React.createElement("button", {
            className: "c-els-pill__close-button",
            onClick: onClose,
            type: "button"
          }, children || label, closeIcon);
        }
        return children || label;
      };
      return /* @__PURE__ */React.createElement("div", {
        className: classes,
        id: id,
        "data-testid": "pill"
      }, renderChildren());
    }
  }]);
}(PureComponent);
Pill.displayName = "Pill";
Pill.propTypes = {
  children: node$1,
  className: string$1,
  condensed: bool$1,
  id: string$1,
  // DEPRECATED: replaced by children
  label: string$1,
  pillColor: string$1,
  textColor: string$1,
  onClick: func$1,
  onClose: func$1
};
Pill.requiredProps = {};
Pill.defaultProps = {
  children: null,
  className: "",
  condensed: null,
  id: null,
  // DEPRECATED: replaced by children
  label: "",
  onClick: null,
  onClose: null,
  pillColor: "",
  textColor: ""
};
var RawPill = Pill;
var Pill$1 = makeErrorBoundComponent(RawPill);
var bool = PT.bool,
  func = PT.func,
  node = PT.node,
  object = PT.object,
  string = PT.string;
var PillWithIcon = function PillWithIcon(props) {
  var children = props.children,
    className = props.className,
    iconColor = props.iconColor,
    iconProps = props.iconProps,
    iconRight = props.iconRight,
    id = props.id,
    onClick = props.onClick,
    onClose = props.onClose,
    pillColor = props.pillColor,
    textColor = props.textColor;
  var pillClasses = classnames(className, {
    "c-els-pill--icon-right": iconRight,
    "c-els-pill--icon-only": !children
  });
  var icon = /* @__PURE__ */React.createElement(Icon, _objectSpread(_objectSpread({
    isDecorative: !!children,
    size: iconProps.size || "xs",
    textAlignment: "sub"
  }, iconProps), {}, {
    className: "c-els-pill__icon ".concat(iconColor ? "u-els-color-".concat(iconColor) : ""),
    fallback: (/* istanbul ignore next */
    function fallback() {
      return children ? "" : iconProps.a11y.name;
    })
  }));
  return /* @__PURE__ */React.createElement(Pill$1, {
    className: pillClasses,
    id: id,
    onClick: onClick,
    onClose: onClose,
    pillColor: pillColor,
    textColor: textColor
  }, iconRight && children, icon, !iconRight && children);
};
PillWithIcon.displayName = "PillWithIcon";
PillWithIcon.propTypes = {
  children: node,
  className: string,
  iconColor: string,
  iconProps: object.isRequired,
  iconRight: bool,
  id: string,
  pillColor: string,
  textColor: string,
  onClick: func,
  onClose: func
};
PillWithIcon.requiredProps = {};
PillWithIcon.defaultProps = {
  children: null,
  className: "",
  iconColor: "",
  iconRight: false,
  id: null,
  onClick: null,
  onClose: null,
  pillColor: "",
  textColor: ""
};
var RawPillWithIcon = PillWithIcon;
var PillWithIcon$1 = makeErrorBoundComponent(RawPillWithIcon);
export { Pill$1 as Pill, PillWithIcon$1 as PillWithIcon, RawPill, RawPillWithIcon };
